const FileExplorer = () => import(/* webpackChunkName: "v-gateway-remote" */ '@/components/page/gateway/remote/file-explorer/FileExplorer')
const Shell = () => import(/* webpackChunkName: "v-gateway-remote" */ '@/components/page/gateway/remote/Shell')
const RemoteCommand = () => import(/* webpackChunkName: "v-gateway-remote" */ '@/components/page/gateway/remote/Command')

const routes = [
  {
    path: 'file-explorer',
    name: 'gatewayFileExplorer',
    component: FileExplorer,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'remote'
    }
  }, {
    path: 'shell',
    name: 'gatewayShell',
    component: Shell,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'remote'
    }
  }, {
    path: 'command',
    name: 'gatewayCommand',
    component: RemoteCommand,
    props: true,
    meta: {
      roles: ['ADMIN', 'SUPER_ADMIN'],
      dropdown: 'remote'
    }
  }
]

export default routes
